import { useEffect, useState } from "react"
import { ApiEndpoints, reqGetNew } from "../../../../config/apiClient"
import styles from "./nfse.module.css"
import dayjs from "dayjs"
import r2slogo from '../../../../img/r2s-logo.png'
import oblogo from '../../../../img/ob-logo.png'
import PlaceholderLoading from "react-placeholder-loading"
import { Button } from "react-bootstrap"

export default function EmpresasSelecaoPage({ handleEmpresaSelected }:iEmpresasSelecaoPage) {
    const [empresas, setEmpresas] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(false)
    const [loadingErro, setLoadingErro] = useState<boolean>(false)

    useEffect(() => {
        document.title = 'NFSe Selecionar empresas | OB PORTUS'
        getDados()
        // eslint-disable-next-line
    }, [])

    const getDados = async () => {
        setLoading(true)
        const api = await reqGetNew(ApiEndpoints.nfEmpresasInfosNFSe)
        if (api.status === 200) {
            setEmpresas(api.data)
            setLoadingErro(false)
            setLoading(false)
        } else {
            setLoadingErro(true)
        }
    }

    async function recarregarDados() {
        setLoadingErro(false)
        await getDados()
    }

    if (loading) {
        return (
            <div>
                <h1 id="titleMain">NFSe Empresas</h1>
                <div className="div-row" style={{marginTop: "10px"}}>
                    <div style={{display: "inline"}}>
                        <PlaceholderLoading shape="rect" width={430} height={128} /><br></br><br></br>
                        <PlaceholderLoading shape="rect" width={430} height={10} /><br></br>
                        <PlaceholderLoading shape="rect" width={430} height={10} /><br></br>
                    </div>
                    <span style={{marginRight: "10px"}}></span>
                    <div style={{display: "inline"}}>
                        <PlaceholderLoading shape="rect" width={430} height={128} /><br></br><br></br>
                        <PlaceholderLoading shape="rect" width={430} height={10} /><br></br>
                        <PlaceholderLoading shape="rect" width={430} height={10} /><br></br>
                    </div>
                    <span style={{marginRight: "10px"}}></span>
                    <div style={{display: "inline"}}>
                        <PlaceholderLoading shape="rect" width={430} height={128} /><br></br><br></br>
                        <PlaceholderLoading shape="rect" width={430} height={10} /><br></br>
                        <PlaceholderLoading shape="rect" width={430} height={10} /><br></br>
                    </div>
                </div>
                <br></br>
                {
                    loadingErro &&
                    <div>
                        <p>Erro ao carregar a dados.</p>
                        <br></br>
                        <Button onClick={() => { recarregarDados() }} style={{ marginRight: "10px" }}>Recarregar Página</Button>
                    </div>
                }
            </div>
        )
    }

    return (
        <div>
            <h1 id="titleMain">NFSe Empresas</h1>
            <div id={styles.listaEmpresas}>
                {
                    empresas.map((empresaInfo, idx, dados) => {
                        let empresa = empresaInfo.empresa;
                        let info = empresaInfo.info
                        empresa["info"] = info
                        return (
                            <div className={styles.painelEmpresa} key={idx}>
                                <div className={styles.painelEmpresaLogo} onClick={() => { handleEmpresaSelected(empresa) }}>
                                    {
                                        empresa.id_empresa === 1 &&
                                        <img src={r2slogo} about="LOGO" alt="LOGO"></img>
                                    }
                                    {
                                        empresa.id_empresa > 1 &&
                                        <img src={oblogo} about="LOGO" alt="LOGO"></img>
                                    }
                                    <h2>{empresa.nome}</h2>
                                </div>
                                <div className={styles.painelEmpresaInfo}>
                                    <p>Notas pendentes: {info.qtd_pendentes}</p>
                                    <br></br>
                                    <p>Notas emitidas: {info.qtd_emitidas}</p>
                                    <p>Valor total: {info.valor_total}</p>
                                    <br></br>
                                    <p>Notas canceladas: {info.qtd_canceladas}</p>
                                    <p>Valor total: {info.valor_cancelado}</p>
                                    <br></br>
                                    <p>Notas emitidas (mes anterior): {info.qtd_emitidas_anterior}</p>
                                    <p>Valor total (mes anterior): {info.valor_total_anterior}</p>
                                    <br></br>
                                    {
                                        empresa.nfs_situacao_simp_nac === 3 &&
                                        <div>
                                            <p>Obtante pelo Simples Nacional - Alíquota {empresa.nfs_ISS}%</p>
                                            <br></br>
                                        </div>
                                    }
                                    {
                                        empresa.nfs_situacao_simp_nac !== 3 &&
                                        <div>
                                            <p>Não obtante pelo Simples Nacional</p>
                                            <br></br>
                                        </div>
                                    }
                                    {
                                        (info.certificado && info.certificado_valido) &&
                                        <p>Certificado válido até: {dayjs(info.certificado_data_expiracao).format("DD/MM/YYYY HH:mm:ss")}</p>
                                    }
                                    {
                                        (info.certificado && !info.certificado_valido) &&
                                        <p><b>CERTIFICADO EXPIRADO</b> em: {dayjs(info.certificado_data_expiracao).format("DD/MM/YYYY HH:mm:ss")}</p>
                                    }
                                    {
                                        (!info.certificado) &&
                                        <p><b>Certificado não configurado.</b></p>
                                    }
                                    {/* {
                                        (item.empresa.data_permissao_final !== null) &&
                                        <p style={{
                                            color: item.permissao_cor_alerta, fontWeight: item.permissao_dias_para_expirar > 31 ? 'normal' : 'bold',
                                        }}>Permissão expira em {item.permissao_dias_para_expirar} dias, {dayjs(item.empresa.data_permissao_final).format("DD/MM/YYYY")}.</p>
                                    }
                                    {item.empresa.data_permissao_prefeitura !== null && <p>Última permissão solicitada em: {dayjs(item.empresa.data_permissao_prefeitura).format("DD/MM/YYYY")}</p>} */}
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

interface iEmpresasSelecaoPage {
    handleEmpresaSelected: any
}